<template>
	<div class="container mt-4">
		<div class="col-12">
			<Loader v-model="loading"></Loader>
			<Categories v-if="path === 'categories'" @changePath="updatePath"></Categories>
			<Capture v-else-if="path === 'capture'" v-model="base64Image" @changePath="updatePath"></Capture>
			<DataValidation v-else-if="path === 'dataValidation'" @changePath="updatePath"></DataValidation>
			<RecapNote v-else-if="path === 'recapNote'" @changePath="updatePath" @saved="saved"></RecapNote>
		</div>
	</div>
</template>


<script setup>
  import { ref, onBeforeMount } from 'vue'
  import { useStore } from 'vuex'
  import { useRoute } from 'vue-router';
  import { useMessage } from 'naive-ui'

  import Capture from '../ExpensesScan/Capture.vue'
  import Categories from '../ExpensesScan/Categories.vue'
  import DataValidation from '../ExpensesScan/DataValidation.vue'
  import RecapNote from '../ExpensesScan/RecapNote.vue'
  import Loader from "../Loader.vue"


  const loading = ref(false)
  const path = ref(null)
  const base64Image = ref(null)
  const ticketDatas = ref(null)
  const store = useStore()
  const route = useRoute()
  const message = useMessage()

  const { getBase64Img, getTicketDatas } = store.getters

  const setBase64Img = (img) => store.dispatch('setBase64Img', img)
  const setTicketDatas = (data) => store.dispatch('setTicketDatas', data)
  const setId = (id) => store.dispatch('setId', id)
  const setCategory = (category) => store.dispatch('setCategory', category)
  const addToast = (msg) => store.dispatch('addToast', msg)

  const updatePath = (newPath) => {
    path.value = newPath
  }

  const saved = (status) => {
    if (status === 'success') {
      message.success('Note de frais sauvegardée')
    } else {
      message.error('Erreur lors de la sauvegarde')
    }
  }

  onBeforeMount(async () => {
    if (route.params.id) {
      loading.value = 'Chargement'
      const res = await store.dispatch('getTicket', route.params.id)
      ticketDatas.value = res.raw.datas
      ticketDatas.value.Nom = {
        name: 'Nom',
        content: res.expand.user.name,
      }
      setTicketDatas(res.raw.datas)
      setCategory(res.category)
      setId(res.id)

      const scanRes = await store.dispatch('getScanUrl', route.params.id)
      base64Image.value = scanRes
      setBase64Img(scanRes)
      path.value = 'categories'
      loading.value = false
    } else {
      path.value = 'categories'
    }

    store.dispatch('setUser')
  })



</script>

<style scoped>
#content {
	max-height: 90vh;
}
</style>